import React from 'react';
import './Home.css';

function Home() {
  return (
    <div className="home-container">
      <div className="hero-section">
        <h1>Sistema de Gera��o de Laudos Audiol�gicos com IA</h1>
        <p className="subtitle">
          Automatize e otimize a gera��o de laudos audiol�gicos com apoio de Intelig�ncia Artificial
        </p>
      </div>

      <div className="features-grid">
        <div className="feature-card">
          <h3>?? Precis�o T�cnica</h3>
          <p>
            Valida��o autom�tica de dados com regras cl�nicas baseadas em normas ISO e ANSI
          </p>
        </div>

        <div className="feature-card">
          <h3>?? Intelig�ncia Artificial</h3>
          <p>
            Gera��o de rascunhos de laudos com justificativas num�ricas e recomenda��es
          </p>
        </div>

        <div className="feature-card">
          <h3>?? Seguran�a e Privacidade</h3>
          <p>
            Conformidade com LGPD, criptografia e logs audit�veis para m�xima seguran�a
          </p>
        </div>

        <div className="feature-card">
          <h3>?? Rastreabilidade</h3>
          <p>
            Hist�rico completo de vers�es e auditorias para garantir conformidade regulat�ria
          </p>
        </div>
      </div>

      <div className="info-section">
        <h2>Fluxo de Trabalho</h2>
        <ol className="workflow-steps">
          <li>Cadastro do paciente e dados do exame</li>
          <li>Valida��o autom�tica de calibra��o e ru�do ambiente</li>
          <li>Processamento por regras cl�nicas (PTA, classifica��o, gaps)</li>
          <li>Gera��o de rascunho de laudo pela IA</li>
          <li>Revis�o e edi��o pelo profissional</li>
          <li>Assinatura digital e exporta��o em PDF</li>
        </ol>
      </div>
    </div>
  );
}

export default Home;
